import React from 'react';
import type { BioRenderableCandidate } from '@axiom/validation';

import { Layout } from '../../layout/Layout/Layout';
import { Paragraph } from '../../content/Paragraph/Paragraph';

import { PDFFooter } from './PdfPageTemplateFooterStyles';

export interface PdfPageTemplateFooterProps {
  pdfProps: { pageNum: number; totalPages: number };
  candidate: BioRenderableCandidate | undefined;
  isAnonymous?: boolean;
}

export const PdfPageTemplateFooter = ({
  pdfProps,
  candidate,
}: PdfPageTemplateFooterProps) => {
  return (
    <Layout position="center">
      <PDFFooter>
        <Layout stretched position="space-between">
          <Paragraph name="PDF_FOOTER_TALENT">
            {candidate?.calculatedDisplayName || 'Axiom Talent'}
          </Paragraph>
          <Paragraph name="PDF_PAGE_NUMBER">Page {pdfProps.pageNum}</Paragraph>
        </Layout>
      </PDFFooter>
    </Layout>
  );
};
